import React from 'react';

import useMartyContext from 'hooks/useMartyContext';

import styles from 'styles/components/common/searchField.scss';

interface Props {
  name: string;
  placeholder?: string;
  value?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => any;
  id: string;
  type?: string;
}

const SearchField = ({ name, placeholder = '', value = '', onChange, type = 'text', id }: Props) => {
  const { testId } = useMartyContext();
  return (
    <div className={styles.searchField}>
      <input
        className={styles.searchTextField}
        name={name}
        placeholder={placeholder}
        type={type}
        id={id}
        data-test-id={testId('searchTextField')}
        value={value}
        onChange={onChange}
      />
    </div>
  );
};

export default SearchField;
